import { buildReducer } from '../../../../shared';
import type RestoreContactsState from '../../../state/restoreContactsState';
import { restoreContactsCompletedAction } from '../../../actions/data/restoreContactsDataActions';
import {
    restoreContactsClickedAction,
    dismissRestoreContactsDialogAction,
} from '../../../actions/user/deletedItems/restoreContactsActions';

export type { RestoreContactsState };

const defaultState: RestoreContactsState = {
    isRestoreInProgress: false,
    restoreContactsFailed: false,
};

export default buildReducer<RestoreContactsState>()
    .handle(restoreContactsClickedAction, state => ({
        ...state,
        restoreContactsFailed: false,
        isRestoreInProgress: true,
    }))
    .handle(dismissRestoreContactsDialogAction, state => ({ ...defaultState }))
    .handleDataAction(
        restoreContactsCompletedAction,
        state => ({ ...state, isRestoreInProgress: false, restoreContactsFailed: false }),
        state => ({ ...state, isRestoreInProgress: false, restoreContactsFailed: true })
    )
    .done(defaultState);
export type { Action } from '../../../../shared';
